import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="relative pt-16 pb-10">

      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent mb-10"></div>

      <div className="max-w-7xl mx-auto px-6 text-center">

        <h3 className="text-2xl font-semibold text-white">
          Diya Jacob
        </h3>

        <p className="text-gray-400 mt-2">
          React.js & React Native Developer
        </p>

        <div className="flex justify-center gap-6 mt-6 text-xl text-gray-300">

          <a
            href="https://github.com/diyajacob001"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-400 transition"
          >
            <FaGithub />
          </a>

          <a
            href="https://www.linkedin.com/in/diya-jacob-34547818a/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-400 transition"
          >
            <FaLinkedin />
          </a>

          <a
            href="mailto:diyajacob.tech@gmail.com"
            className="hover:text-blue-400 transition"
          >
            <FaEnvelope />
          </a>

        </div>

        <p className="text-gray-500 text-sm mt-8">
          © {new Date().getFullYear()} Diya Jacob. All rights reserved.
        </p>

      </div>

    </footer>
  );
}

export default Footer;